import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOpening = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 8.7,
		cy: 8.7,
		r: 8,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		transform: "translate(.337 .337)"
	})
});
export { SvgOpening as ReactComponent };
